module.exports = __webpack_public_path__ + "assets/185bc1de98f44c701fffdec6caeac8cb.mp3";